import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { VimeoUploadService } from '../services/vimeo-upload.service';
import { getVideoThumbnail } from '../utilities/video.utils';

@Pipe({
  name: 'vimeoThumbnail',
})
export class VimeoThumbnailPipe implements PipeTransform {
  constructor(private vimeoService: VimeoUploadService) {}

  transform(videoUrl: string, isPublic?: boolean): Observable<string | undefined> {
    if (!videoUrl) {
      return of(undefined);
    }
    if (isPublic) {
      return this.vimeoService
        .getPublicVimeoThumbnail(videoUrl)
        .pipe(
          map((thumbnail) => thumbnail ?? getVideoThumbnail(videoUrl)),
          catchError(() => of(undefined)),
        );
    }
    return this.vimeoService
      .getVimeoThumbnail(new URL(videoUrl))
      .pipe(catchError(() => of(undefined)));
  }
}
